import { render, staticRenderFns } from "./ofacprincipal.vue?vue&type=template&id=0c7c7f2a"
import script from "./ofacprincipal.vue?vue&type=script&lang=js"
export * from "./ofacprincipal.vue?vue&type=script&lang=js"
import style0 from "./ofacprincipal.vue?vue&type=style&index=0&id=0c7c7f2a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports